import { proxy } from 'valtio';

interface ExportMenuState {
  selectedValue: { id: string; text: string }[];
  submitted: boolean;
}

export const defaultExportMenu: ExportMenuState = {
  selectedValue: [],
  submitted: false,
};

export const currentExportMenuState: ExportMenuState = proxy(defaultExportMenu);
